import React from 'react';
import './LandingPage.css'

export default function PortosFooter() {
  return (
    <footer className="footer"  >
      <div className="footer-links">
        <div className="quick-links">
          <h3>Quick Links</h3>
          <div className="links-columns">
            <ul>
              <li><a href="#hero">Home</a></li>
              <li><a href="#features">Features</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#contactus">Contact Us</a></li>
            </ul>
            <ul>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Resources</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Terms & Conditions</a></li>
            </ul>
          </div>
        </div>

        <div className="company-info">
          <h4>Turnkey Insights (I) Pvt. Ltd</h4>
          <p>
            20/23, U Block, 10th Street, Anna Nagar,<br />
            Chennai, Tamil Nadu, India - 600040.
          </p>
          <a href="mailto:info@turnkeylearning.com">info@turnkeylearning.com</a>
          <div className="social-icons">
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
              <div className="social-icon-container">
                <img src="/images/icons/linkedin.png" alt="LinkedIn" className="social-icon" />
              </div>
            </a>
            <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">
              <div className="social-icon-container">
                <img src="/images/icons/youtube.png" alt="YouTube" className="social-icon" />
              </div>
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
              <div className="social-icon-container">
                <img src="/images/icons/twitter.png" alt="Twitter" className="social-icon" />
              </div>
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <div className="social-icon-container">
                <img src="/images/icons/instagram.png" alt="Instagram" className="social-icon" />
              </div>
            </a>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <div className="social-icon-container">
                <img src="/images/icons/facebook.png" alt="Facebook" className="social-icon" />
              </div>
            </a>
          </div>


        </div>

        <div className="newsletter">
          <h4>Stay updated</h4>
          <p>
            Sign-up for our newsletter and get all the updates delivered to your inbox. (No spam, we promise!)
          </p>
          <label>Email *</label>
          <input type="email" placeholder="Enter your email" />
          <button>Submit</button>
        </div>
      </div>
      <div className="footer-bottom">
        © 2025 by Turnkey Learning. Developed by Digital Rebel.
      </div>
    </footer>
  );
};


